'use client';

import { ThemeProvider as NextThemeProvider } from 'next-themes';
import type { ThemeProviderProps } from 'next-themes';

export type TmsThemeProviderProps = ThemeProviderProps;

export function TmsThemeProvider(props: TmsThemeProviderProps) {
  return <NextThemeProvider attribute="class" disableTransitionOnChange {...props} />;
}
